import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	TableCell,
	TableRow,
	MenuItem,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

import { useMenu } from 'hooks';
import { formatDisplayDate } from 'lib/utils';
import moment from 'moment';
import React from 'react';

const PromoCodeItem = ({
	promo,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();
	const isSelected = selectedIds.includes(promo.id);

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(promo, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(promo, e)}>Delete</MenuItem>
		</Menu>
	);

	return (
		<TableRow
			hover
			onClick={() => handleClick(promo)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(promo)}
						name="topic"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Typography variant="primary.text">{promo.promo_code}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{formatDisplayDate(promo.created_at)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{formatDisplayDate(promo.expiration_date)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{promo.current_redeems}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{promo.active ? 'Active' : 'Inactive'}
				</Typography>
			</TableCell>

			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default PromoCodeItem;
